/*
 * Object.prototype.toString 기반 타입 문자열. 구 Object.prototype.typeToString 대체.
 * 예) {} → 'object', [] → 'array', 'a' → 'string', null → 'null', undefined → 'undefined'
 *
 * 주 사용처는 populate 여부 판별(`typeToString(x) == 'object'`)이다.
 */
export const typeToString = (value: unknown): string => {
  const match = {}.toString.call(value).match(/\s([a-zA-Z]+)/)
  return (match?.[1] ?? '').toLowerCase()
}
